module.exports = __webpack_public_path__ + "img/computer8.2be3e501.gif";